import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { from, map, of, switchMap, take } from 'rxjs';
import { hasTotpSignIn } from '../../utils/auth-state';

export const AccountGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AngularFireAuth);

  return auth.authState.pipe(
    take(1),
    switchMap(user => user ? from(hasTotpSignIn(user)) : of(false)),
    map(isAuthenticated => isAuthenticated ? router.createUrlTree(['/home']) : true)
  );
};
